import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './ModelComponentTypeList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

const ModelComponentTypeListTable = ({
  paginatedData = [],
  RemoveModelComponentType,
  ChangeModelComponentType,
  UpdateAllowed,
  DeleteAllowed,
  IsOwner,
  intl
}) => {
  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="modelComponentTypes.name" defaultMessage="Name" />
            </th>
            <th>
              <FormattedMessage id="modelComponentTypes.description" defaultMessage="Description" />
            </th>
            {(IsOwner && (UpdateAllowed || DeleteAllowed)) && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <Fragment key={n.ModelComponentTypeId}>
                <tr data-unittest="modelComponentTypeData">
                  <td>{n.Name}</td>
                  <td>{n.Description}</td>
                  {(IsOwner && (UpdateAllowed || DeleteAllowed)) && (
                    <td className={s.btnCol}>
                      {UpdateAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          onClick={() => {
                            ChangeModelComponentType(n.ModelComponentTypeId);
                          }}
                          data-unittest="changeData"
                        >
                          <FormattedMessage id="common.edit" defaultMessage="EDIT" />
                        </Button>
                      )}
                      {DeleteAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.removeButton}
                          onClick={() => {
                            RemoveModelComponentType(n.ModelComponentTypeId);
                          }}
                          data-unittest="removeData"
                        >
                          <FormattedMessage id="modelComponentTypes.remove" defaultMessage="Remove" />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};


ModelComponentTypeListTable.propTypes = {
  paginatedData: PropTypes.array.isRequired,
  RemoveModelComponentType: PropTypes.func.isRequired,
  ChangeModelComponentType: PropTypes.func.isRequired,
  UpdateAllowed: PropTypes.bool,
  DeleteAllowed: PropTypes.bool,
  IsOwner: PropTypes.bool
};

export default injectIntl(ModelComponentTypeListTable);
